import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Header from './Header';
import Leftbar from './Leftbar';
// import { useSelector } from "react-redux";
import SiteDashboard from './Dashboard/SiteDashboard';
import Workflow from './Workflow/index';
import Tags from './Tag/index';
import { useSelector } from 'react-redux';
import Versions from './Versions/index';
import UserWorkflows from './UserWorkflows/index';



const Approuter = () => {
  const userData = useSelector((state) => state.userSlice);
  return (
    <>
      <BrowserRouter>
        <div id="layout-wrapper">
          <div id="layout-wrapper">
            <Header />
            <Leftbar />
          </div>
          <Routes>
            <Route path={`/dashboard/:groupId`} element={<SiteDashboard />}  />
            <Route path={`/workflows/:groupId`} element={<Workflow />}  /> 
            <Route path={`/workflow/tasks/:w_id/:v_id`} element={<Versions />}  /> 
            <Route path={`/user/workflows/:userID`} element={<UserWorkflows />}  /> 
            <Route path={`/tags/:groupId`} element={<Tags />}  /> 
            <Route path='*' element={<Navigate to={`/dashboard/${userData.user.group.uuid}` } />} />
          </Routes>
        </div>
      </BrowserRouter>
    </>
  )
}

export default Approuter